import React, { useEffect } from "react";
import { Card, Row, Col, Spin } from "antd";
import TenantsImg from "../../../assets/images/totalTenants.png";
import UsersImg from "../../../assets/images/totalUser.png";
import PodcastImg from "../../../assets/images/totalPodcast.png";
import MostPopularImg from "../../../assets/images/mostPopulars.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardCount } from "../../../redux/reducer/dashboardSlice";
import DashboardCardLoader from "../../../components/common/loader/DashboardCardLoader";

const DashboardCards = ({tenantId, dashboardUserData}) => {

  const dispatch = useDispatch();
  const {dashboardCountData, dashboardCountLoading} = useSelector((prev) => prev.dashboard)
  console.log(dashboardUserData?.total_user, "snddff")

  useEffect(()=>{
    let payload = {}
    if(tenantId === null){
      payload = {}
    }else{
      payload = { tenant_id: tenantId }
    }
    dispatch(fetchDashboardCount(payload))
  },[dispatch, tenantId])


const cardData = [
  {
    title: "Total Tenants",
    value: dashboardCountData?.tenant_count,
    icon: <img src={TenantsImg} alt={TenantsImg} />,
    color: "#48B7D614",
  },
  {
    title: "Total Users",
    value: dashboardCountData?.user_count,
    icon: <img src={UsersImg} alt={UsersImg} />,
    color: "#FFA60014",
  },
  {
    title: "Active Users",
    value: dashboardCountData?.active_user,
    icon: <img src={UsersImg} alt={UsersImg} />,
    color: "#FFA60014",
  },
  {
    title: "Total Podcasts",
    value: dashboardCountData?.total_podcast,
    icon: <img src={PodcastImg} alt={PodcastImg} />,
    color: "#45AE5114",
  },
 
];

  return (
    <Row gutter={[16, 16]}>
      {dashboardCountLoading ? <DashboardCardLoader /> : cardData?.map((item, index) => (
        <Col xs={24} sm={12} md={12} lg={6} key={index}>
          <Card
            style={{
              borderRadius: 15, 
              padding: 0,
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* Left Side - Title & Value */}
              <div className="leftBx">
                <p>{item.title}</p>
                <h3 style={{ margin: 0 }}>{item.value}</h3>
              </div>

              {/* Right Side - Icon Box */}
              <div className="icon" style={{ backgroundColor: item.color }}>
                <span>{item.icon}</span>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardCards;
